import React from 'react';
import Styles from './styles.module.sass';

import BoxGeneral from './BoxGeneralUpperfooter';

export default function UpperFooter(props) {
    const {
        contentSecion
    } = props

    return (
        <div className={Styles?.upperfooter}>
            {
                contentSecion?.length >= 1
                    ?
                        contentSecion?.map((typeUpperF, index) => (
                                <BoxGeneral key={index} contentSecion={typeUpperF} />
                            ))
                    : null
            }
        </div>
    )
}